export enum ExperienceCategory {
    CATEGORY_70 = 70,
    CATEGORY_100 = 100,
    CATEGORY_200 = 200,
    CATEGORY_300 = 300,
    CATEGORY_400 = 400,
    CATEGORY_500 = 500,
    CATEGORY_600 = 600,
    CATEGORY_700 = 700,
    CATEGORY_800 = 800,
    CATEGORY_1000 = 1000,
}
